import axiosInstance from './axiosConfig';

export interface ScannerCornersResult {
    detected: boolean;
    corners: [number, number][];
    image_size: { width: number; height: number };
}

/**
 * Llama al backend de OpenCV para detectar automáticamente los 4 vértices del documento.
 */
export const detectDocumentCornersApi = async (
    imageBase64OrFile: string | File
): Promise<ScannerCornersResult> => {
    let payload: any;
    const headers: Record<string, string> = {};

    if (typeof imageBase64OrFile === 'string') {
        if (imageBase64OrFile.startsWith('blob:')) {
            const res = await fetch(imageBase64OrFile);
            const blob = await res.blob();
            const formData = new FormData();
            formData.append('image', blob, 'capture.jpg');
            payload = formData;
            headers['Content-Type'] = 'multipart/form-data';
        } else {
            payload = { image_base64: imageBase64OrFile };
        }
    } else {
        const formData = new FormData();
        formData.append('image', imageBase64OrFile);
        payload = formData;
        headers['Content-Type'] = 'multipart/form-data';
    }

    const response = await axiosInstance.post<ScannerCornersResult>('scanner/detect-corners/', payload, { headers });
    return response.data;
};

/**
 * Aplica corrección de perspectiva y realce de documento en el backend usando OpenCV.
 */
export const processDocumentApi = async (
    imageBase64OrFile: string | File,
    corners: { x: number; y: number }[] | [number, number][],
    filterMode: 'magic' | 'bw' | 'original' = 'magic'
): Promise<{ dataUrl: string; blob: Blob }> => {
    const formData = new FormData();

    if (typeof imageBase64OrFile === 'string') {
        if (imageBase64OrFile.startsWith('blob:')) {
            const res = await fetch(imageBase64OrFile);
            const blob = await res.blob();
            formData.append('image', blob, 'capture.jpg');
        } else {
            formData.append('image_base64', imageBase64OrFile);
        }
    } else {
        formData.append('image', imageBase64OrFile);
    }

    // Normalizar coordenadas a array de pares [x, y]
    const formattedCorners = corners.map((p: any) => (Array.isArray(p) ? p : [Math.round(p.x), Math.round(p.y)]));
    formData.append('corners', JSON.stringify(formattedCorners));
    formData.append('filter_mode', filterMode);

    const response = await axiosInstance.post('scanner/process-document/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'image/webp' });
    const dataUrl = URL.createObjectURL(blob);
    return { dataUrl, blob };
};
